import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../components/Card';
import Typography from '../components/Typography';
import Loader from '../components/Loader';
import Button from '../components/Button';
import { makeStyles } from '@material-ui/core';
import { selectCover } from '../redux/quoteDuck';

const useStyles = makeStyles({
  header: {
    padding: '0 8px'
  },
  hello: {
    fontSize: '26px',
    fontWeight: '600',
    margin: '20px 0 15px'
  },
  model: {
    fontSize: '16px',
    margin: '20px 0 20px',
    lineHeight: '1.7'
  },
  card: {
    marginBottom: '15px'
  },
  description: {
    fontSize: '16px',
    margin: '20px 0 20px',
    textAlign: 'center'
  },
  price: {
    fontSize: '32px',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: '20px'
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '15px',
    padding: '0 16px'
  },
  button: {
    height: '44px'
    // border: '0'
  },
  none: {
    display: 'none'
  }
});

export const FinalStep = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { fetching, galeno } = useSelector((state) => state.quote);
  const covers = useSelector((state) => state.quote.galeno.coberturas);
  const { car, person } = useSelector((state) => state);

  const handleSelectCover = (cover) => {
    dispatch(selectCover(cover));

    history.push('/detalle');
  };

  const filteredCovers = (covers) => covers.filter((cover) => cover.cobertura !== 'E');

  if (fetching) return <Loader history={history} />;

  return (
    <>
      <div className={classes.header}>
        <Typography text={`👋 Hola ${person.name}!`} variant='h2' className={classes.hello} />
        <Typography
          text={`Te mostramos las cotizaciones para tu ${car.model}, modelo ${car.year}.`}
          variant='h2'
          className={classes.model}
        />
      </div>

      {covers &&
        filteredCovers(covers).map((cover) => (
          <div key={cover.item} className={classes.card}>
            <Card variant='outlined'>
              <Typography text={cover.descripcionCobertura} variant='h2' className={classes.description} />
              <Typography text={`$ ${Math.round(cover.premio)}`} variant='h2' className={classes.price} />
              <div className={classes.wrapper}>
                <Button
                  text='Detalles'
                  variant='outlined'
                  color='inherit'
                  className={classes.button}
                  onClick={() => handleSelectCover(cover)}
                />
                <Button
                  text='Continuar'
                  color='secondary'
                  className={classes.button}
                  href={`https://api.whatsapp.com/send?phone=5492613281511&text=*DETALLE%20DE%20COTIZACION%20NRO%20${
                    galeno.solicitud
                  }*%0A%0A*CLIENTE*%0A*Nombre:*%20${person.name}%0A*Edad:*%20${
                    person.age
                  }%0A%0A*VEHICULO*%0A*Marca:*%20${car.brand}%0A*Modelo:*%20${car.version}%0A*Año:*%20${
                    car.year
                  }%0A%0A*SEGURO*%0A*Aseguradora:*%20GALENO%0A*Cobertura:*%20${
                    cover.descripcionCobertura
                  }%0A*Precio:*%20$${Math.round(cover.premio)}`}
                  target={'_blank'}
                />
              </div>
            </Card>
          </div>
        ))}
    </>
  );
};
